/**
 * Filter function for getting only events created by specific foles
 * @param {Object} event
 * @returns {Boolean}
 */
const filterNotificationEventsByRole = event => {
  const { authorRoles } = event.context.eventSource;
  const benchRoles = ['USER', 'SALES', 'MANAGER'];
  return authorRoles.find(role => benchRoles.includes(role));
};

/**
 * Filter function for getting only events that a client would want to be
 * notified about
 * @param {Object} event
 * @returns {Boolean}
 */
const filterNotificationEventsForClient = event => {
  if (event.name === 'feed.fds.connection_failed.notification') {
    return true;
  }

  return filterNotificationEventsByRole(event);
};

/**
 * @typedef {Object} Notification
 * @property {Array.<Object>} assets
 * @property {Object} context
 * @property {String} personId
 * @property {Object} payload
 * @property {Object} resources
 *
 * Formats `eventing`'s event data to play nice with bl-notification-list.
 * @param {Object} event
 * @returns {Notification}
 */
const formatEventAssetData = event => {
  const payload = event.assets
    .filter(asset => asset.assetType === 'payload')
    .reduce((acc, val) => ({ ...acc, [val.payloadName]: val.payload }), {});
  const resources = event.assets
    .filter(asset => asset.assetType === 'resource')
    .reduce((acc, val) => ({ ...acc, [val.resource]: val.resourceId }), {});

  return {
    ...event,
    payload,
    resources,
  };
};

/**
 * Takes the raw gateway response and formats it for the UI.
 * @param {Object} data
 * @returns {Array.<Notification>}
 */
const getNotificationsFromResponseData = data =>
  data.notifications[0].events.full
    .filter(filterNotificationEventsForClient)
    .map(formatEventAssetData);

export default getNotificationsFromResponseData;
